import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import {
  TourInstallmentDto,
  TourInstallmentConfigurationDto,
  ConfigureInstallmentTemplatesRequest,
} from '@/features/dashboard/tourConfig/types/TourInstallmentDto.ts';
import { PriceRangeDto } from '@/features/shared/pricing/types/PriceRangeDto.ts';

const tourInstallmentsApi = {
  writeInstallments: async (
    tourId: string,
    request: ConfigureInstallmentTemplatesRequest,
  ): Promise<void> => {
    return await fetchPrivateApi<void>(
      'POST',
      `tours/${tourId}/installment-templates`,
      request,
    );
  },
  getInstallments: async (
    tourId: string,
  ): Promise<TourInstallmentConfigurationDto> => {
    return await fetchPrivateApi<TourInstallmentConfigurationDto>(
      'GET',
      `tours/${tourId}/installment-templates`,
    );
  },
  getPriceRanges: async (tourId: string): Promise<PriceRangeDto[]> => {
    return await fetchPrivateApi<PriceRangeDto[]>(
      'GET',
      `tours/${tourId}/installment-templates/price-range`,
    );
  },

  getInstallmentRanges: async (
    tourId: string,
    tourInstallments: TourInstallmentDto[],
  ): Promise<PriceRangeDto[][]> => {
    return await fetchPrivateApi<PriceRangeDto[][]>(
      'POST',
      `tours/${tourId}/installment-templates/price-range-per-installment`,
      tourInstallments,
    );
  },
};

export default tourInstallmentsApi;
